export default __webpack_public_path__ + "static/media/germany.893759cd.png";